import React from 'react';
import { FormattedMessage } from 'react-intl';
import intlMessages from '../../../intl/messages';

export const TipsAndTricks: React.FC = () => {
  return (
    <div className='rounded border border-slate-300 dark:bg-slate-800 my-4'>
      <div className='p-5'>
        <h4 className='text-2xl font-medium mb-3'>
          🎯 <FormattedMessage {...intlMessages.tipsAndTricks} />
        </h4>
        <ul className='list-none mt-3 text-left'>
          <li className='mb-2'>
            <strong>
              <FormattedMessage {...intlMessages.startWithTheObvious} />
            </strong>{' '}
            <FormattedMessage {...intlMessages.focusOnRowsOrColumns} />
          </li>
          <li className='mb-2'>
            <strong>
              <FormattedMessage {...intlMessages.useBothDirections} />
            </strong>{' '}
            <FormattedMessage {...intlMessages.progressInOneDirection} />
          </li>
          <li className='mb-2'>
            <strong>
              <FormattedMessage {...intlMessages.markYourEmptySpaces} />
            </strong>{' '}
            <FormattedMessage {...intlMessages.useARedX} />
          </li>
          <li className='mb-2'>
            <strong>
              <FormattedMessage {...intlMessages.countCarefully} />
            </strong>{' '}
            <FormattedMessage
              {...intlMessages.separateNumbersMeanDifferentGroups}
            />
          </li>
          <li className='mb-2'>
            <strong>
              <FormattedMessage {...intlMessages.largeNumberClues} />
            </strong>{' '}
            <FormattedMessage {...intlMessages.largeNumberCluesDescription} />
          </li>
          <li className='mb-2'>
            <strong>
              <FormattedMessage {...intlMessages.stayOrganized} />
            </strong>{' '}
            <FormattedMessage {...intlMessages.stayOrganizedDescription} />
          </li>
          <li className='mb-2'>
            <strong>
              <FormattedMessage {...intlMessages.dontGuess} />
            </strong>{' '}
            <FormattedMessage {...intlMessages.dontGuessDescription} />
          </li>
        </ul>
      </div>
    </div>
  );
};
